export const deliveryTurfCsvCell = data => data.office.name

export const deliveryLocationCsvCell = data => data.turn_in_location.name

export const deliveryRunnerCsvCell = data => data.canvasser.full_name

export const DeliveryFormsAttachedCsvCell = data =>
  data.attached_forms_count || 0
